import { getEnvVar } from "@/utils/env";
import { createFetch } from "@vueuse/core";
import { Ref } from "vue";

const baseUrl = getEnvVar("VITE_BASE_URL");

declare const window: {
  sso: object;
} & Window;

const useSPAFetch = (
  url: string | Ref<string>,
  options: object = {},
  onCancel?: () => void
) => {
  const useFetch = createFetch({
    baseUrl,
    options: {
      updateDataOnError: true,
      async beforeFetch({ options, cancel }) {
        try {
          const token = await window.sso.getUserToken();

          if (!token) {
            cancel();
            if (onCancel) {
              onCancel();
            }
          }

          options.headers = {
            ...options.headers,
            Authorization: `Bearer ${token}`,
          };

          return { options };
        } catch (e) {
          cancel();
          if (onCancel) {
            onCancel();
          }
        }
      },
    },
    fetchOptions: {
      mode: "cors",
    },
  });
  return {
    ...useFetch(url, options),
  };
};

export default useSPAFetch;
